import * as React from "react";
import { DetailsList, DetailsListLayoutMode, SelectionMode } from "@fluentui/react/lib/components/DetailsList";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { CpbxApiHelper } from "../../helpers/CpbxApiHelper";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import { Image, IImageProps } from "@fluentui/react/lib/components/Image";
import AppVersionInfo from "../AppVersionInfo/AppVersionInfo";
import AppFeedback from "../AppFeedback/AppFeedback";
import CpbxPaginationSimple from "../CpbxPagination/CpbxPaginationSimple";
import { IWebexPresenceIconProps } from "../Webex/WebexPresenceIcon/IWebexPresenceIconProps";
import WebexPresenceIcon from "../Webex/WebexPresenceIcon/WebexPresenceIcon";
import { SearchBox } from "@fluentui/react/lib/components/SearchBox/SearchBox";
import { ActionButton } from "@fluentui/react/lib/components/Button/ActionButton/ActionButton";
import { Fabric } from "@fluentui/react/lib/components/Fabric/Fabric";
import { Loader } from "@fluentui/react-northstar/dist/es/components/Loader/Loader";
import { Segment } from "@fluentui/react-northstar/dist/es/components/Segment/Segment";
import { ConstantsHttpHeader } from "../../constants/ConstantsHttpHeader";
import { ConstantsBrowserLocalCache } from "../../constants/ConstantsBrowserLocalCache";
import { WindowRestoreIcon, Button } from "@fluentui/react-northstar";
import DecommissionDialog from "../DecommissionDialog/DecommissionDialog";

// const filterIcon: IIconProps = { iconName: "Filter" };

// data from local storage about the token
export function isAccessTokenForWebExStatusValid(jsonAsString: any): boolean {
    try {
        const parseJsonAsString = JSON.parse((jsonAsString === undefined || jsonAsString === "") ? "{\"access_token_exists\":false}" : jsonAsString);
        console.log("start isAccessTokenForWebExStatusValid");
        if (parseJsonAsString === null || parseJsonAsString === undefined || parseJsonAsString.access_token_is_expired || parseJsonAsString.access_token_exists === false) {
            console.log("!isAccessTokenForWebExStatusValid return false");
            return false;
        } else {
            console.log("!isAccessTokenForWebExStatusValid return true");
            return true;
        }
    } catch (e) {
        console.log(e);
        return false;
    }
}

export async function copyTextToClipboard(text) {
    try {
        await navigator.clipboard.writeText(text);
        console.log("copied");
    } catch (err) {
        console.error("workaround this", err);
        console.log("navigator: ", navigator);
        const input = document.createElement("input");
        document.body.appendChild(input);
        input.value = text;
        input.focus();
        input.select();
        document.execCommand("copy");
        input.remove();
    }

}

initializeIcons();
// initializeReactIcons(/* optional base url */);
export interface IListItem {
    lastNameAndFirstName: string;
    firstName: string;
    lastName: string;
    number: string;
    extension: string;
    mobile: string;
    emailAddress: string;
}

interface IColumn {
    key: string;
    name: any;
    fieldName?: string;
    minWidth: number,
    isResizable?: boolean;
    maxWidth: number;
    isSorted?: boolean;
    isSortedDescending?: boolean;
}

const controlStyles = {
    root: {
        margin: "0 30px 20px 0",
        maxWidth: "300px"
    }
};

// https://developer.microsoft.com/en-us/fluentui#/controls/web/detailslist
export default class CpbxDirectory extends React.Component {

    private lcCpbxUn: string;
    private lcCpbxBa: string;
    private lcCpbxUserIv: string;
    private lcM365UserObjectId: string;
    private apiUrlFull: string;
    private reqHeaders: Headers;
    private maxLengthSearchInput: number = 100;
    private cpbxUserTypeIs2: boolean = false;
    private numberOfEntriesLS: number = 50;
    private saveLSAdressBookInDays: number;

    /* Image-Logo */
    private imageProps: Partial<IImageProps> = {
        src: "/assets/logo-corner-big.svg"
    };

    private imagePropsMobile: Partial<IImageProps> = {
        src: "/assets/logo-corner-small.svg"
    };
    /* Image-Logo */

    private _columns: IColumn[] = [
        // {
        //     key: "column1",
        //     name: "Status",
        //     fieldName: "userId",
        //     minWidth: 100,
        //     isResizable: true
        // },
        {
            key: "column2",
            name: "Name",
            fieldName: "lastNameAndFirstName",
            minWidth: 150,
            isResizable: true,
            maxWidth: 300,
            isSorted: true,
            isSortedDescending: false
        },
        // {
        //     key: "column2",
        //     name: "Name",
        //     fieldName: "firstName",
        //     minWidth: 150,
        //     isResizable: true,
        //     maxWidth: 250
        // },
        {
            key: "column3",
            name: "Telefon",
            fieldName: "number",
            minWidth: 110,
            isResizable: true,
            maxWidth: 200
        },
        {
            key: "column4",
            name: "Interne Rufnummer",
            fieldName: "extension",
            minWidth: 100,
            isResizable: true,
            maxWidth: 150
        },
        {
            key: "column5",
            name: "Mobil",
            fieldName: "mobile",
            minWidth: 100,
            isResizable: true,
            maxWidth: 200
        },
        {
            key: "column6",
            name: "E-Mail",
            fieldName: "emailAddress",
            minWidth: 200,
            isResizable: true,
            maxWidth: 250
        }
        // {
        //     key: "column7",
        //     name: "Nachname",
        //     fieldName: "lastName",
        //     minWidth: 150,
        //     isResizable: true,
        //     maxWidth: 250
        // }
    ];

    /* eslint-disable */
    constructor(props) {
        super(props);
        this.onKeyUp = this.onKeyUp.bind(this);
    }
    /* eslint-enable */

    state = {
        items: [],
        itemsFilteredAndSorted: [],
        itemsToShow: [],
        arrColumnDefinition: this._columns,
        IsLoadedInitially: false,
        IsChangingValue: false,
        currentPageNo: 1,
        resultsPerPageNo: 7,
        maxPageNo: 1,
        totalResultsNo: 0,
        sortColumnName: "",
        currentFilterValue: "",
        currentTextSearch: "",
        currentTextSearchLastSubmit: "",
        isSortedDescending: false,
        tokenItemURL: "",
        tokenExpiresAt: "",
        showTokenDialog: false,
        dataCiscoTokenForGroup: null
    };

    componentDidMount() {
        // console.log("start componentDidMount CpbxDirectory");
        this.lcCpbxUn = LocalCacheHelper.GetLocalStorageItemCbpxUserNameAsString();
        this.lcCpbxBa = LocalCacheHelper.GetLocalStorageItemCbpxUserBasicAuthStringAsString();
        this.lcCpbxUserIv = LocalCacheHelper.GetLocalStorageItemCbpxUserIVString();
        this.lcM365UserObjectId = LocalCacheHelper.GetLocalStorageItemM365UserObjectId();
        this.reqHeaders = CpbxApiHelper.GetCpbxRequestHeadersWithAuthPsa(this.lcCpbxBa, this.lcM365UserObjectId, this.lcCpbxUserIv);
        this.cpbxUserTypeIs2 = LocalCacheHelper.GetLocalStorageItemCpbxUserType() === "2";
        this.saveLSAdressBookInDays = parseInt(process.env.APP_DATA_LOCALSTORAGE_ADDRESSBOOK_SAVE_IN_MIN ?? "2880", 10) * (1000 * 60);
        if (this.cpbxUserTypeIs2) {
            this._columns.unshift({
                key: "column1",
                name: <span title="Status des Nutzers in Cloud PBX">Status</span>,
                fieldName: "webexPresence",
                minWidth: 40,
                isResizable: false,
                maxWidth: 80
            });
            const temp = LocalCacheHelper.GetLocalStorageCiscoTokenForGroup();
            // console.log("temp = '" + temp + "'");
            if (temp !== "") {
                const jsonExecutedAtUc = JSON.parse(temp).executed_at_utc;
                console.log("jsonExecutedAtUc = '" + jsonExecutedAtUc + "'");
                const diffExecutedAtUtcInMin = Math.round((Date.now() - Date.parse(jsonExecutedAtUc)) / 1000 / 60);
                console.log("diffExecutedAtUtcInMin = '" + diffExecutedAtUtcInMin + "'");
                const maxTimeAsStringFromEnv = process.env.APP_SOFTWARE_CISCO_TOKEN_EXISTS_FOR_GROUP_IN_MIN ?? "5";
                console.log("maxTimeAsStringFromEnv = '" + maxTimeAsStringFromEnv + "'");
                const maxTimeInMin = parseInt(maxTimeAsStringFromEnv, 10);
                console.log("maxTimeInMin = '" + maxTimeInMin + "'");

                if (diffExecutedAtUtcInMin >= maxTimeInMin) {
                    console.log("remove cache-entry");
                    LocalCacheHelper.SetLocalStorageCiscoTokenForGroup("");
                } else {
                    console.log("do not remove cache-entry");
                }
            }
        }
        this.addEventListener();
        this.getCpbxDirectoryEntries();
    }

    // re-render
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.dataCiscoTokenForGroup !== prevState.dataCiscoTokenForGroup) {
            console.log("start componentDidUpdate CpbxDirectory CiscoTokenForGroup Received");
            this.getCpbxDirectoryEntries();
        }
    }

    // special for apple-devices and apple-browsers to ensure that iframes do the login-check
    // (other devies and browsers refresh the iframe when user navigates away and back to it - but not apple)
    addEventListener() {
        document.addEventListener("visibilitychange", function (event) {
            console.log("document.hidden='" + document.hidden + "'");
            if (document.hidden) {
                console.log("not visible");
            } else {
                console.log("is visible");
                const isCpbxLoggedIn: boolean = LocalCacheHelper.DoesLocalCacheKeysForCbpxLoginExists();
                console.log("isCpbxLoggedIn='" + isCpbxLoggedIn + "'");
                if (isCpbxLoggedIn === false) {
                    console.log("not logged in > do reload to show login-component");
                    window.location.reload();
                }
            }
        });
    }

    getCpbxDirectoryEntries() {
        this.getCpbxDirectoryEntriesWithFilterValue("", this.state.currentPageNo, this.state.sortColumnName);
    }

    getTransformCpbxJsonToExpectedListArray(items) {
        // remove entries not exesting phone number holder
        const allNoTelItems = items.flat().filter(function (el: any) {
            // !!el.number.$ - Not undefined
            return !!el.number && el.number !== "" && el.firstName.$ !== "Voice Portal" && el.lastName.$ !== "Voice Portal";
        });
        // console.log("items: ", items);
        const tempTransformCpbxJsonToExpectedListArray2 = this.transformCpbxJsonToExpectedListArray2(allNoTelItems);

        // now sort by name in ascending order (default sorting)
        const temparrayFilteredAndSorted = tempTransformCpbxJsonToExpectedListArray2.sort((a: any, b: any) => (
            (a.lastNameAndFirstName.toLowerCase() > b.lastNameAndFirstName.toLowerCase()) ? 1 : -1));
        // console.log("items: ", items);
        return temparrayFilteredAndSorted;
    }

    getCpbxDirectoryEntriesWithFilterValue(filterValue: string, noOfPage: number, sortColumn: string) {
        // console.log("start getCpbxDirectoryEntriesWithFilterValue: ");
        // console.log("filterValue='" + filterValue + "'");
        // console.log("noOfPage='" + noOfPage + "'");
        // console.log("sortColumn='" + sortColumn + "'");

        // this.apiUrlFull = CpbxApiHelper.GetCpbxUrlForDirectoriesEnterpriseDefault(this.lcCpbxUn);

        const startAt: number = 1 + ((noOfPage - 1) * this.state.resultsPerPageNo);
        // console.log("startAt='" + startAt + "'");
        this.apiUrlFull = CpbxApiHelper.GetCpbxUrlForDirectoriesEnterpriseSubset(
            this.lcCpbxUn, startAt, this.state.resultsPerPageNo, sortColumn, filterValue);
        // pay attention that url has not to be greater than 360...
        // - depending on proxy-url-length the max-length of search-text should be 20
        // - apiUrlFull='https://telekomicpbx-proxy-devtmp.azurewebsites.net/cpbxapi/v2.0/com.broadsoft.xsi-actions/v2.0/user/axels@deutschland-lan.de/directories/Enterprise?format=json&start=1&results=7&sortColumn=lastName&searchCriteriaModeOr=true&firstName=*axel1234561234567890*/i&lastName=*axel1234561234567890*/i&extension=*axel1234561234567890*/i&mobileNo=*axel1234561234567890*/i' (length=362)
        // console.log("apiUrlFull='" + this.apiUrlFull + "' (length=" + this.apiUrlFull.length + ")");
        /* const cpbxItems = [
            {
                userId: "551126975220gg78882.gruppenfkt.1290@deutschland-lan.de",
                firstName: "Accenture",
                lastName: "Test",
                number: "+49228410126910"
            },
            {
                userId: "551126975220gg78882.gruppenfkt.1290-B@deutschland-lan.de",
                firstName: "Accenture-B",
                lastName: "Test-B",
                number: "+492284101269105"
            },
        ]; */
        const noEntriesPerRequest: number = 50;
        let count = 1;
        let max = 0;
        const items: any = [];
        let part: any = [];
        const urls: any = [];
        const localStorageAddressbookUpdate: any = {};
        // first request to the server about the maximum(max) number of records in the book
        fetch(CpbxApiHelper.GetCpbxUrlForDirectoriesEnterpriseSubset(
            this.lcCpbxUn, 1, 1, "", ""), {
            method: "GET",
            headers: this.reqHeaders,
            redirect: "follow"
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else if (response.status === 401) {
                console.log("not authorised");

                // simulate logout and reload the current page to avoid user-lock / user-deactivation
                // hint: maybe the user changed the password in another system; we stored the (old) credentials
                LocalCacheHelper.RemoveLocalCacheKeysForCbpxLogin();
                localStorage.clear();
                window.location.reload();
            } else {
                throw new Error("Response not ok");
            }
        }).then(data => {
            console.log("Fetch data: ", data);
            max = parseInt(data.Enterprise.totalAvailableRecords.$);
            // console.log("Max: " + max);
            if (max === 0) {
                console.log("No Entries found");
                this.setState({
                    IsLoadedInitially: true
                });
                return;
            }
            for (count = 1; count <= max; count = count + noEntriesPerRequest) {
                urls.push(CpbxApiHelper.GetCpbxUrlForDirectoriesEnterpriseSubset(this.lcCpbxUn, count, noEntriesPerRequest, sortColumn, filterValue));
                // console.log("Urls: ", urls);
            }
            count = 1;
            let block = 1;
            if (LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc().length === 0 ||
                JSON.parse(LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc()).noOfRecords !== max ||
                Date.now() - Date.parse(JSON.parse(LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc()).dateUtc) > this.saveLSAdressBookInDays
            ) {
                while (localStorage.getItem(ConstantsBrowserLocalCache.KeyAddressBookRecordsPartPrefix + count)) {
                    localStorage.removeItem(ConstantsBrowserLocalCache.KeyAddressBookRecordsPartPrefix + count);
                    console.log("remove: " + ConstantsBrowserLocalCache.KeyAddressBookRecordsPartPrefix + count);
                    count++;
                }
                count = 1;
                Promise.all(
                    urls.map(urli =>
                        fetch(urli, {
                            method: "GET",
                            headers: this.reqHeaders,
                            redirect: "follow"
                        }).then(response => {
                            if (response.ok) {
                                return response.json();
                            } else {
                                throw new Error("Response not ok");
                            }
                        }).then(data => {
                            // console.log("got data DirectoryEntries");
                            console.log("data url:", data);
                            items.push(data.Enterprise.enterpriseDirectory.directoryDetails);
                            const tempTransformCpbxJsonToExpectedListArray = this.getTransformCpbxJsonToExpectedListArray(items);
                            this.setState({
                                IsLoadedInitially: true,
                                sortColumnName: sortColumn,
                                items: tempTransformCpbxJsonToExpectedListArray,
                                itemsFilteredAndSorted: tempTransformCpbxJsonToExpectedListArray
                                // arrColumnDefinition: this.getColumnsDefinitionWithSortorder("lastNameAndFirstName")
                            });
                            localStorageAddressbookUpdate.noOfRecords = max;
                            localStorageAddressbookUpdate.dateUtc = new Date().toISOString();
                            LocalCacheHelper.SetLocalStorageAddressBookRecordsAndAtDateTimeUtc(JSON.stringify(localStorageAddressbookUpdate));
                            part.push(data.Enterprise.enterpriseDirectory.directoryDetails);
                            // if ( block === Math.ceil(max/50)/Math.ceil(max/this.numberOfEntriesLS) ) {
                            if (block === Math.ceil(this.numberOfEntriesLS / 50)) {
                                localStorage.setItem(ConstantsBrowserLocalCache.KeyAddressBookRecordsPartPrefix + count, JSON.stringify(part.flat()));
                                count++;
                                block = 0;
                                part = [];
                            }
                            block++;
                            this.getItemsToShow(this.state.currentPageNo, this.state.currentFilterValue, "lastNameAndFirstName", false);
                        })
                    )
                );
            } else { // This means that the records are saved in the local memory. And there is no need to send new requests to the server yet.
                while (localStorage.getItem(ConstantsBrowserLocalCache.KeyAddressBookRecordsPartPrefix + count)) {
                    const temp: any = localStorage.getItem(ConstantsBrowserLocalCache.KeyAddressBookRecordsPartPrefix + count);
                    items.push(JSON.parse(temp));
                    count++;
                }

                // if the number of Addressbook records stored does not match the number of records on the server, then the data is overwritten
                if (items.flat().length !== JSON.parse(LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc()).noOfRecords) {
                    console.log("Some entries have been deleted. Re-loading the data. ", items.flat().length, " ", JSON.parse(LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc()).noOfRecords);
                    // localStorage.removeItem("localStorageAddressbookUpdate");
                    LocalCacheHelper.SetLocalStorageAddressBookRecordsAndAtDateTimeUtc("");
                    console.log("LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc().length ", LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc().length);
                    console.log("Lokal speicher", LocalCacheHelper.GetLocalStorageAddressBookRecordsAndAtDateTimeUtc());
                    this.getCpbxDirectoryEntries();
                    return;
                }
                const tempTransformCpbxJsonToExpectedListArray = this.getTransformCpbxJsonToExpectedListArray(items);

                this.setState({
                    IsLoadedInitially: true,
                    sortColumnName: sortColumn,
                    items: tempTransformCpbxJsonToExpectedListArray,
                    itemsFilteredAndSorted: tempTransformCpbxJsonToExpectedListArray
                }, () =>
                    this.getItemsToShow(this.state.currentPageNo, this.state.currentFilterValue, "lastNameAndFirstName", false)
                );
            }
        }).catch(
            error => console.log("error", error)
        );

        if (this.cpbxUserTypeIs2) {
            this.callingAccessTokenChecker();
        }
    }

    checkAccessToken(data) {

        if (data.access_token_is_expired) {
            console.log("access_token_exists for", LocalCacheHelper.GetLocalStorageItemCbpxUserGroupIdFromProfileMe());
            this.setState({
                tokenItemURL: data.link_to_refresh_token,
                tokenExpiresAt: new Date(data.refresh_token_expires_at_utc).toLocaleDateString(),
                showTokenDialog: true
            });
        } else if (data.access_token_exists === false || data.refresh_token_is_expired) {
            console.log("access_token_not_exists");
            this.setState({
                tokenItemURL: data.link_to_create_token,
                tokenExpiresAt: new Date(data.access_token_expires_at_utc).toLocaleDateString() ?? "null",
                showTokenDialog: true
            });
        } else {
            this.setState({
                showTokenDialog: false
            });
        }
    }

    callingAccessTokenChecker() {

        const ciscoTokenForGroupAsString = LocalCacheHelper.GetLocalStorageCiscoTokenForGroup();
        console.log("helpvar='" + ciscoTokenForGroupAsString + "'");
        const cacheExists = ciscoTokenForGroupAsString !== undefined && ciscoTokenForGroupAsString !== "";
        console.log("cacheExists='" + cacheExists + "'");
        if (cacheExists === true) {
            this.checkAccessToken(ciscoTokenForGroupAsString);
        } else {
            console.log("HEADERS: ", ConstantsHttpHeader.XTeamsAppCpbx1GroupId, LocalCacheHelper.GetLocalStorageItemCbpxUserGroupIdFromProfileMe());
            console.log("API URL: ", LocalCacheHelper.GetLocalStorageItemCbpxProxyUrl());
            // const proxyHeaders = new Headers();
            // proxyHeaders.append(ConstantsHttpHeader.XTeamsAppCpbx1GroupId, LocalCacheHelper.GetLocalStorageItemCbpxUserGroupIdFromProfileMe());
            fetch(LocalCacheHelper.GetLocalStorageItemCbpxProxyUrl() + "/psa/CiscoTokenExistsForGroup/", {
                method: "GET",
                headers: this.reqHeaders,
                redirect: "follow"
            }).then((response) => {
                console.log("response.ok='" + response.ok + "'");
                console.log("response.status='" + response.status + "'");
                console.log("response.statusText='" + response.statusText + "'");
                console.log("response.redirected='" + response.redirected + "'");
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Response not ok");
                }
            }).then((data) => {
                console.log("proxy Data: ", data);
                if (data.access_token_exists === true && data.access_token_is_expired === false) {
                    LocalCacheHelper.SetLocalStorageCiscoTokenForGroup(JSON.stringify(data));

                    // This forces the componenten to render again (which is needed to run _renderItemColumn with the correct localStorage-entry again). [Addtional info: needed for #1375]
                    this.setState({
                        dataCiscoTokenForGroup: data
                    });
                }
                this.checkAccessToken(data);
            }).catch((error) => {
                console.log("Es ist ein unerwarteter Fehler beim Ermitteln des CPBX-GroupId aufgetreten: ", error);
            });
        }
    };

    // will be used by
    // initially called getItemsToSho
    // pagination
    // Changed on search
    getItemsToShow(inpCurrentPageNo: number, inpCurrentFilterValue: string, inpSortColumnName: string, doNotclickFindbutton: boolean) {
        /**
         * Filter
         * Sortieren
         * Slice()
         */
        let arrayFilteredAndSorted: any = null;
        // console.log("itemsToShow1 ", this.state.itemsToShow);

        if (inpCurrentFilterValue !== this.state.currentFilterValue) {
            console.log("filter nach ", inpCurrentFilterValue);
            arrayFilteredAndSorted = this.state.items
                .filter(function (el: any) {
                    return (el.lastNameAndFirstName.toLowerCase() +
                        " " +
                        el.lastName.toLowerCase() +
                        " " +
                        el.firstName.toLowerCase() +
                        " " +
                        el.number +
                        " " +
                        el.emailAddress.toLowerCase() +
                        " " +
                        el.mobile
                    ).indexOf(inpCurrentFilterValue.toLowerCase()) !== -1;
                });

        } else {
            arrayFilteredAndSorted = this.state.itemsFilteredAndSorted;
        }

        if ((inpSortColumnName === this.state.sortColumnName && this.state.isSortedDescending === true && doNotclickFindbutton === true)) {
            console.log("true");
            this.setState({ isSortedDescending: false });
            arrayFilteredAndSorted = arrayFilteredAndSorted.sort((a: any, b: any) => (
                (a[inpSortColumnName].toLowerCase() > b[inpSortColumnName].toLowerCase()) ? 1 : -1)
            );
        }
        if ((inpSortColumnName === this.state.sortColumnName && this.state.isSortedDescending === false && doNotclickFindbutton === true)) {
            console.log("false");
            this.setState({ isSortedDescending: true });
            arrayFilteredAndSorted = arrayFilteredAndSorted.sort((a: any, b: any) => (
                (a[inpSortColumnName].toLowerCase() < b[inpSortColumnName].toLowerCase()) ? 1 : -1)
            );
        }
        if ((inpSortColumnName === this.state.sortColumnName && doNotclickFindbutton === false)) {
            arrayFilteredAndSorted = arrayFilteredAndSorted.sort((a: any, b: any) => (
                (this.state.isSortedDescending
                    ? a[inpSortColumnName].toLowerCase() < b[inpSortColumnName].toLowerCase()
                    : a[inpSortColumnName].toLowerCase() > b[inpSortColumnName].toLowerCase())
                    ? 1
                    : -1
            )
            );
        }
        if (inpSortColumnName !== this.state.sortColumnName) {
            this.setState({ isSortedDescending: false });
            arrayFilteredAndSorted = arrayFilteredAndSorted.sort((a: any, b: any) => (
                (a[inpSortColumnName].toLowerCase() > b[inpSortColumnName].toLowerCase()) ? 1 : -1)
            );
        }

        const sliceStart: number = inpCurrentPageNo * this.state.resultsPerPageNo - this.state.resultsPerPageNo;
        const sliceEnd: number = sliceStart + this.state.resultsPerPageNo;
        const arrayToShow = arrayFilteredAndSorted.slice(sliceStart, sliceEnd);
        const noOfTotRecords: number = arrayFilteredAndSorted.length;
        const maxPageNoForRecords: number = Math.floor((noOfTotRecords - 1) / this.state.resultsPerPageNo) + 1;
        this.setState({
            itemsToShow: arrayToShow,
            currentPageNo: inpCurrentPageNo,
            maxPageNo: maxPageNoForRecords,
            totalResultsNo: noOfTotRecords,
            sortColumnName: inpSortColumnName,
            currentFilterValue: inpCurrentFilterValue,
            itemsFilteredAndSorted: arrayFilteredAndSorted
        });

    }

    // getItemsToShow2(inpCurrentPageNo: number, inpCurrentFilterValue: string, inpSortColumnName: string, inpDoInvertSorting:boolean) {
    //     /**
    //      * Filter
    //      * Sortieren
    //      * Slice()
    //      */
    //     let arrayFilteredAndSorted: any = null;
    //     console.log("inpCurrentFilterValue", inpCurrentFilterValue);
    //     if (inpCurrentFilterValue !== "") {
    //         arrayFilteredAndSorted = this.state.items
    //             .filter(function (el: any) {
    //                 return (el.lastNameAndFirstName.toLowerCase() +
    //                     " " +
    //                     el.lastName.toLowerCase() +
    //                     " " +
    //                     el.firstName.toLowerCase() +
    //                     " " +
    //                     el.number +
    //                     " " +
    //                     el.emailAddress.toLowerCase() +
    //                     " " +
    //                     el.mobile
    //                 ).indexOf(inpCurrentFilterValue.toLowerCase()) !== -1;
    //             });

    //     } else {
    //         arrayFilteredAndSorted = this.state.itemsFilteredAndSorted;
    //     }

    //     if (inpSortColumnName !== this.state.sortColumnName ) {
    //         this.setState({ isSortedDescending: false });

    //         arrayFilteredAndSorted = arrayFilteredAndSorted.sort((a: any, b: any) => (
    //             ( a[inpSortColumnName].toLowerCase() > b[inpSortColumnName].toLowerCase()) ? 1 : -1 )
    //         );
    //     }

    //     if (inpSortColumnName === this.state.sortColumnName && inpDoInvertSorting ) {
    //         this.setState({ isSortedDescending: !this.state.isSortedDescending });

    //         arrayFilteredAndSorted = arrayFilteredAndSorted.sort((a: any, b: any) => (
    //             (this.state.isSortedDescending
    //                 ? a[inpSortColumnName].toLowerCase() > b[inpSortColumnName].toLowerCase()
    //                 : a[inpSortColumnName].toLowerCase() < b[inpSortColumnName].toLowerCase())
    //                 ? 1
    //                 : -1
    //         )
    //         );
    //     }
    //     const sliceStart: number = inpCurrentPageNo * this.state.resultsPerPageNo - this.state.resultsPerPageNo;
    //     const sliceEnd: number = sliceStart + this.state.resultsPerPageNo;
    //     const arrayToShow = arrayFilteredAndSorted.slice(sliceStart, sliceEnd);
    //     const noOfTotRecords: number = arrayFilteredAndSorted.length;
    //     const maxPageNoForRecords: number = Math.floor((noOfTotRecords - 1) / this.state.resultsPerPageNo) + 1;

    //     this.setState({
    //         itemsToShow: arrayToShow,
    //         currentPageNo: inpCurrentPageNo,
    //         maxPageNo: maxPageNoForRecords,
    //         totalResultsNo: noOfTotRecords,
    //         sortColumnName: inpSortColumnName,
    //         currentFilterValue: inpCurrentFilterValue,
    //         tempVaritemsFilteredAndSorted: arrayFilteredAndSorted
    //     });
    // }

    transformCpbxJsonToExpectedListArray(cpbxJson): IListItem[] {
        let listArr: IListItem[] = [];
        /* const listArr = [
            {
                userId: "551126975220gg78882.gruppenfkt.1290@deutschland-lan.de",
                firstName: "Accenture",
                lastName: "Test",
                number: "+49228410126910"
            },
            {
                userId: "551126975220gg78882.gruppenfkt.1290-B@deutschland-lan.de",
                firstName: "Accenture-B",
                lastName: "Test-B",
                number: "+492284101269105"
            },
        ]; */
        if (cpbxJson.Enterprise.numberOfRecords.$ > 0) {

            if (parseInt(cpbxJson.Enterprise.numberOfRecords.$) === 1) {
                const dd = cpbxJson.Enterprise.enterpriseDirectory.directoryDetails;
                const e = this.getDirectoryDetailEntryByJson(dd);
                listArr.push(e);
            } else {
                const dd = cpbxJson.Enterprise.enterpriseDirectory.directoryDetails;
                listArr = dd.map(item => {
                    // console.log(item);
                    const e = this.getDirectoryDetailEntryByJson(item);
                    return e;
                });
            }
        }

        return listArr;
    }

    transformCpbxJsonToExpectedListArray2(cpbxJson): IListItem[] {
        let listArr: IListItem[] = [];
        const dd = cpbxJson;
        listArr = dd.map(item => {
            const e = this.getDirectoryDetailEntryByJson(item);
            return e;
        });
        return listArr;
    }

    private getColumnsDefinitionWithSortorder(colNameSorted: string): IColumn[] {
        const newColDef: IColumn[] = this.state.arrColumnDefinition.map(col => {
            col.isSorted = col.fieldName === colNameSorted;
            if (col.isSorted) {
                col.isSortedDescending = col.isSortedDescending === undefined ? false : !col.isSortedDescending;
            } else {
                col.isSortedDescending = true;
            }
            return col;
        });
        return newColDef;
    }

    private getDirectoryDetailEntryByJson(dd): IListItem {
        // e.g. axels@deutschland-lan.de
        // const uidFull: string = dd.userId.$;
        // e.g. axels
        // const uidLight = uidFull.split("@")[0];
        // e.g. axels@imp003.deutschland-lan.de > not each entry provides this additionDetails-stuff...
        const uImpId = (dd.additionalDetails && dd.additionalDetails.impId) ? dd.additionalDetails.impId.$ : "";

        const e = {
            // userId: uidLight,
            userId: dd.userId.$,
            lastNameAndFirstName: dd.lastName.$ + ", " + dd.firstName.$,
            firstName: dd.firstName.$,
            lastName: dd.lastName.$,
            number: (dd.number !== undefined) ? dd.number.$ : "",
            extension: (dd.extension !== undefined) ? dd.extension.$ : "",
            mobile: (dd.additionalDetails !== undefined && dd.additionalDetails.mobile !== undefined) ? dd.additionalDetails.mobile.$ : "",
            emailAddress: (dd.additionalDetails !== undefined && dd.additionalDetails.emailAddress !== undefined) ? dd.additionalDetails.emailAddress.$ : "",
            webexPresence: dd.userId.$
        };
        return e;
    }

    private _onChangeFilterTextSearch = (ev: React.ChangeEvent<HTMLInputElement>, text: string): void => {
        // console.log(text, "OnChangefilter");

        let tempText: string = text;
        let textNeedsChange: boolean = false;

        // check input for max-length
        // this is stupid i know - we need to check max-length here because SearchBox has no property for maxLength...
        if (text.length > this.maxLengthSearchInput) {
            // console.log("length of searched text (" + text.length + ") is greater than allowed (" + this.maxLengthSearchInput + ").");
            textNeedsChange = true;
            tempText = text.slice(0, this.maxLengthSearchInput);
        }
        // do further checks
        // const searchRegExp: RegExp = /^.\S{0,51}@.\S{0,51}\..\S{0,14}$/si;
        // const searchRegExp: RegExp = /^[a-zA-Z0-9äöüß, -]*$/si;
        // - there are many other characters (chinese, french,... which should be allowed)
        /* const searchRegExp: RegExp = /^[^<>%?!]*$/si;
        if (searchRegExp.test(tempText.toLowerCase()) === false) {
            this.setState({
                unErrMsg: "Unerlaubte Zeichen enthalten.",
                unValueIsValid: false
            });
            return;
        } */

        // re-set input-value to allowed value
        if (textNeedsChange === true) {
            // console.log("need to change value from '" + text + "' to '" + tempText + "'.");
            (ev.target as HTMLInputElement).value = tempText;
        }

        this.setState({
            currentTextSearch: tempText
        });
    };

    private _onClickFilterTextSearch = (): void => {
        // console.log("onClickFilterTextSearch2");
        this.setState({
            currentTextSearchLastSubmit: this.state.currentTextSearch
        });
        this.getItemsToShow(1, this.state.currentTextSearch, this.state.sortColumnName, false);
    };

    private onKeyUp(event) {
        // console.log("onKeyUp [event.keyCode='" + event.keyCode + "']");
        if (event.keyCode === 13) {
            // this.setState({ inputValue: event.target.value });
            this._onClickFilterTextSearch();
        }
    }

    private onClickCreateTokenButton(event) {
        // someone wants a new token > so we have to remove data from cache to force user to retrieve the new token data next time
        LocalCacheHelper.SetLocalStorageCiscoTokenForGroup("");

        // open url from proxy-component in new window (register-card in browser)
        // if we open this url in this window directly this would result in confusion because in teams-register-card there is no history-back-function
        // so it seems to be easier to use new window with final result-words like "success - please close this window now"
        window.open(this.state.tokenItemURL, "_blank");

        // hide dialog + button
        this.setState({
            showTokenDialog: false
        });
    }

    private _onChangePage2(currentPageNo: number): void {
        // console.log("set page to '" + currentPageNo + "'");
        this.getItemsToShow(currentPageNo, this.state.currentFilterValue, this.state.sortColumnName, false);
    };

    private _onColumnHeaderClick = (event: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        console.log("_onColumnHeaderClick [column.fieldName='" + column.fieldName + "']");
        // check if supported columns have to sorted
        const colFieldName: string = (column.fieldName !== undefined) ? column.fieldName : "";
        if (colFieldName === "" || colFieldName === "webexPresence") {
            console.log("fieldName is undefined or webexPresence");
            return;
        }
        console.log("do resorting now");
        this.getItemsToShow(1, this.state.currentFilterValue, colFieldName, true);
        this.getColumnsDefinitionWithSortorder(colFieldName);
    };

    private _renderItemColumn(item: IColumn, index: number, column: IColumn) {
        const fieldContent = item[column.fieldName as keyof IColumn] as string;
        const tempDate = Date.now();

        console.log(" _renderItemColumn ", tempDate);
        console.log("isAccessTokenForWebExStatusValid(LocalCacheHelper.GetLocalStorageCiscoTokenForGroup()) === ", isAccessTokenForWebExStatusValid(LocalCacheHelper.GetLocalStorageCiscoTokenForGroup()));
        console.log("LocalCacheHelper.GetLocalStorageCiscoTokenForGroup() === ", LocalCacheHelper.GetLocalStorageCiscoTokenForGroup());

        const itemcopy: any = item;
        console.log("itemcopy.userId", itemcopy.userId);
        if (fieldContent.length === 0) {
            return <span>{fieldContent}</span>;
        } else {
            const cssClassName = ("cpbxDirectory" + column.fieldName);
            let contextPropsPresenceIcon: IWebexPresenceIconProps;

            switch (column.fieldName) {
                case "webexPresence":

                    // pay attention: hasValidAccessToken may be false as long as entry in localStorage has not been set. Will be set within callingAccessTokenChecker. [additional info: see #1375]
                    contextPropsPresenceIcon = {
                        cpbxIntEmail: itemcopy.userId,
                        doUpdateStatus: true,
                        updateDelayInSec: 10,
                        doShowIntEmailInTitle: false,
                        doShowDateTimeInTitle: false,
                        uniqueTimeStamp: tempDate,
                        hasValidAccessToken: isAccessTokenForWebExStatusValid(LocalCacheHelper.GetLocalStorageCiscoTokenForGroup())
                    };
                    return <>
                        {LocalCacheHelper.GetLocalStorageItemCpbxUserType() === "2" ? <WebexPresenceIcon {...contextPropsPresenceIcon} /> : <></>}
                    </>;
                case "emailAddress":
                    return <span className={cssClassName}>
                        <a className ={"cpbxmailto"} href={"mailto:" + fieldContent}>{fieldContent}{"⠀"}</a>
                        <Button title="In Zwischenablage kopieren" circular size="small" content="Override feed" loader="Reboot sensor" className="iconClipboardCopy" onClick={() => { copyTextToClipboard(fieldContent); }} >
                            <WindowRestoreIcon />
                        </Button>
                    </span>;
                case "number":
                case "mobile":
                    return <span className={cssClassName}><a href={"tel:" + fieldContent} target="_blank" rel="noreferrer">{fieldContent}</a></span>;
                case "lastNameAndFirstName":
                    return <>
                        <span className={cssClassName}>{fieldContent}</span>
                    </>;
                default:
                    return <span className={cssClassName}>{fieldContent}</span>;
            }
        }
    }

    render() {

        // first build a complete return-element which depends on some variables (conditional rendering)
        let retAll;
        const cpbxHeaderRow = (
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl6 ms-xlPush8 ms-xxlPush6 cpbxContInner cpbxContInnerLogo">
                    <div className="cpbxBgLogoCont">
                        <Image className="cpbxBgLogo" {...this.imageProps} alt="TelekomLogo" />
                    </div>
                    <div className="cpbxBgLogoCont"><Image className="cpbxBgLogoMobile" {...this.imagePropsMobile} alt="TelekomLogo" /></div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl8 ms-xxl6 ms-xlPull4 ms-xxlPull6 cpbxContInner">
                    <div className="cpbxHeader"><h1>Unternehmensverzeichnis</h1></div>
                    <div className="cpbxText"><p>Hier finden Sie alle Cloud PBX Benutzer, die im Unternehmensverzeichnis der Cloud PBX Ihres Unternehmens hinterlegt sind. Darüber hinaus finden Sie unter Umständen auch Benutzer, die nicht in Ihrem Microsoft Teams Adressbuch gelistet sind.</p></div>
                </div>
            </div>
        );
        const cpbxFooterRow = (
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner cpbxFooter">
                    <div className="cpbxVersionText">
                        <AppVersionInfo />
                    </div>
                    <div className="cpbxFeedbackLink"><AppFeedback /></div>
                </div>
            </div>
        );

        const cpbxSearchBox = (
            <SearchBox
                title="Die Suche berücksichtigt Vorname, Nachname, Endung der internen Telefonnummer sowie die Mobilnummer. Groß- und Kleinschreibung ist nicht relevant."
                // placeholder="Gib hier Deine Suchparameter ein (Vorname, Nachname, Endung der internen Telefonnummer sowie die Mobilnummer)"
                placeholder="Suchen Sie nach Vor-, Nachname, interner Rufnummer oder Mobilnummer eines Kontaktes"
                onChange={this._onChangeFilterTextSearch}
                // iconProps={filterIcon}
                className={"cpbxDirectoryretSearchBox "}
                id="cpbxDirectoryretSearchBox"
                onKeyUp={this.onKeyUp}
            />
        );
        const retFilterTextField = (
            <div>
                <div className="cpbxDirectoryretSearchBoxBtnCont">
                    {cpbxSearchBox}
                    <div className="cpbxDirectoryretActionButtonDiv">
                        <ActionButton text="Suchen" onClick={this._onClickFilterTextSearch} className="cpbxDirectoryretActionButton" id="EnterActionBtn"></ActionButton>
                    </div >
                </div>
            </div>
        );

        const getTokenButton = (
            <div>
                {this.state.showTokenDialog && this.cpbxUserTypeIs2
                    ? <div className="doshowAcceptDialog cpbxTokenDialog">
                        <p className="doshowAcceptDialogText cpbxTokenDialogText"> Bitte erteilen Sie die Erlaubnis zur Anzeige des Status. </p>
                        <ActionButton
                            onClick={event => this.onClickCreateTokenButton(event)}
                            className="doshowAcceptDialogButton cpbxTokenButton"
                        >Erlaubnis erteilen
                        </ActionButton>
                    </div >
                    : <></>
                }
            </div>
        );

        if (this.state.IsLoadedInitially === false) {
            retAll = (
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner">
                    {retFilterTextField}
                    <div>
                        <Segment className="cpbxLoaderSegment">
                            <Loader size='large'>Loading</Loader>
                        </Segment>
                    </div>
                </div>
            );
        } else {

            if (this.state.totalResultsNo === 0) {
                retAll = (
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner">
                        {retFilterTextField}
                        <div className="cpbxDirectoryretDetailsListResult">
                            <p>Keine Ergebnisse</p>
                        </div>
                    </div>
                );
            } else {
                const retDetailsList = (
                    <div className={"cpbxDirectoryDetailsListDiv " + this.state.IsLoadedInitially ? "isVisible" : "notVisible"}>
                        <DetailsList
                            items={this.state.itemsToShow}
                            columns={this.state.arrColumnDefinition}
                            layoutMode={DetailsListLayoutMode.justified}
                            selectionMode={SelectionMode.none}
                            onColumnHeaderClick={this._onColumnHeaderClick}
                            onRenderItemColumn={this._renderItemColumn}
                            className={"cpbxDirectoryretDetailsList "}
                        />
                    </div>
                );

                if (this.state.totalResultsNo <= this.state.resultsPerPageNo) {
                    // no pagination needed
                    retAll = (
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner">
                            {retFilterTextField}
                            {retDetailsList}
                        </div>
                    );
                } else {
                    // pagination needed
                    let currItemsNoTo = (this.state.currentPageNo * this.state.resultsPerPageNo);
                    if (this.state.totalResultsNo < currItemsNoTo) currItemsNoTo = this.state.totalResultsNo;
                    const currItemsNoFrom = (this.state.currentPageNo * this.state.resultsPerPageNo) - this.state.resultsPerPageNo + 1;

                    let cssClassValue: string = "cpbxDirectoryPaginationCont";
                    if (this.state.currentPageNo === 1) {
                        cssClassValue += " isFirstPage";
                    }
                    if (this.state.currentPageNo === this.state.maxPageNo) {
                        cssClassValue += " isLastPage";
                    }

                    const retPagination = (
                        <div className={cssClassValue}>
                            <CpbxPaginationSimple
                                currentPage={this.state.currentPageNo}
                                totalPages={this.state.maxPageNo}
                                // onClick = {(page) => this._onChangePage(page)}
                                onClick={(page) => this._onChangePage2(page)}
                                text={currItemsNoFrom + "-" + currItemsNoTo + " / " + this.state.totalResultsNo}
                            />
                        </div>
                    );

                    retAll = (
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner">
                            {retFilterTextField}
                            {retDetailsList}
                            {retPagination}
                        </div>
                    );
                }
            }
        }

        return (
            <Fabric >
                <div className="cpbxContOuter ms-Grid cpbxContOuterDirectory">
                    {cpbxHeaderRow}
                    <div className="ms-Grid-row">
                        {retAll}
                    </div>
                    {cpbxFooterRow}
                </div>
                {getTokenButton}
                <DecommissionDialog/>
            </Fabric >
        );
    }
}
